import { render, staticRenderFns } from "./Asset_info.vue?vue&type=template&id=72ff4db0"
import script from "./Asset_info.vue?vue&type=script&lang=js"
export * from "./Asset_info.vue?vue&type=script&lang=js"
import style0 from "./Asset_info.vue?vue&type=style&index=0&id=72ff4db0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports